module.exports = __webpack_public_path__ + "static/media/viaggi.b2f3cd4c.jpg";